import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import qs from "query-string";

import { SignUpType } from "@faire/retailer/lib/popSignUp";
import { AppHistory } from "@faire/retailer/packages/core/services/AppHistory";
import { ProductPagePaths } from "@faire/retailer/paths/ProductPage";

export interface IGenerateProductSignUpUrlProps {
  productToken: string | undefined;
  brandToken: string | undefined;
  productOptionToken?: string | undefined;
  isShowRefB?: boolean;
  refF?: string[];
  refC?: string | undefined;
}

export const generateProductUrlForLoggedOutRetailer = ({
  productToken,
  brandToken,
  productOptionToken,
  isShowRefB,
  refF,
  refC,
}: IGenerateProductSignUpUrlProps): string | undefined => {
  if (!productToken) {
    return undefined;
  }
  const productPageLink = ProductPagePaths.index(productToken);
  if (isPrerender()) {
    return productPageLink;
  }
  const { location } = AppHistory.get().history;

  return `${location.pathname}?${qs.stringify({
    ...qs.parse(location.search),
    signUp: SignUpType.PRODUCT,
    brand: brandToken,
    product: productToken,
    productOptionToken: productOptionToken,
    refB: isShowRefB ? brandToken : undefined,
    refC,
    refF,
  })}`;
};
